import * as React from "react";
import {
  IconProvider,
  ViewportProvider,
  LocalizationContext,
  LoggerProvider
} from "./index.js";
import { BackwardCompatibleLocalization } from "./backward-compatible-localization.js";
import { egenciaViewportContext } from "./viewport-context.js";
import { egenciaIconConfig } from "./icon-context.js";
import { egenciaLoggerContext } from "./logger-context.js";
import { EgenciaDialogProvider } from "./egencia-dialog-provider.js";
import * as uitoolkit from "../uitoolkit/index.js";
const EgenciaContext = React.createContext({ injected: false });
export function EgenciaProvider(props) {
  const egenciaLocalization = new BackwardCompatibleLocalization(props.locale ?? uitoolkit.EG?.currentLocale);
  if (props.localizations) {
    egenciaLocalization.setLocalizations(props.localizations);
  }
  if (props.locale) {
    egenciaLocalization.setLocale(props.locale);
  }
  const logger = props.logger ?? egenciaLoggerContext;
  const dialogOnDismiss = props.dialogOnDismiss ?? (() => {
  });
  const dialogLocationHashUpdate = props.dialogLocationHashUpdate ?? true;
  return /* @__PURE__ */ React.createElement(EgenciaContext.Consumer, null, ({ injected }) => injected ? props.children : /* @__PURE__ */ React.createElement(EgenciaContext.Provider, { value: { injected: true } }, /* @__PURE__ */ React.createElement(
    ViewportProvider,
    {
      viewSizes: egenciaViewportContext.viewSizes,
      baseFontSizePx: egenciaViewportContext.baseFontSizePx
    },
    /* @__PURE__ */ React.createElement(LocalizationContext.Provider, { value: egenciaLocalization }, /* @__PURE__ */ React.createElement(IconProvider, { config: egenciaIconConfig }, /* @__PURE__ */ React.createElement(
      EgenciaDialogProvider,
      {
        onDismiss: dialogOnDismiss,
        locationHashUpdate: dialogLocationHashUpdate
      },
      /* @__PURE__ */ React.createElement(LoggerProvider, { logger }, props.children)
    )))
  )));
}
;
